import React, { useState } from 'react';
import Box from '@mui/material/Box';
import orderHelpers from '../../helpers/orders';
import WalmartPalletLabelsForm from './WalmartPalletLabelsForm';
import WalmartPalletLabelsTable from './WalmartPalletLabelsTable';

function WalmartPalletLabels(props) {

    const [orderInfo, setOrderInfo] = useState(null);
    const [additionalPalletCounts, setAdditionalPalletCounts] = useState({});

    const getBulkOrderInfo = async (search) => {

        props.setLoading(true);

        try {
            const response = await orderHelpers.getBulkOrderPalletInfo(props.company, props.token, search);

            if (response?.isAxiosError) {
                console.log(response);
                props.toast?.error("Encountered an error while retrieving the order.");
                return;
            }
            console.log("Bulk Order Info:", response);
            setOrderInfo(response.order_info);

        } catch (err) {
            console.log(err);
            props.toast?.error("Encountered an error while retrieving the order.");

        } finally {
            props.setLoading(false);
        }
    };

    const generatePalletLabels = async (order, additionalPalletCount) => {
        props.setLoading(true);

        try {
            const response = await orderHelpers.generateAdditionalPalletLabels(props.company, props.token, order.internal_po_number, additionalPalletCount);
            
            if (response.success) {
                props.toast?.success(`Generated ${additionalPalletCount} pallet labels for PO ${order.internal_po_number}.` );
            }
            else {
                props.toast?.error(`Failed to generate pallet labels for PO ${order.internal_po_number}.`);
            }

        } catch (error) {
            console.log(error);

            props.toast?.error(
                `Failed to generate pallet labels for PO ${order.internal_po_number}.`
            );

        } finally {
            props.setLoading(false);
        }
    };

    return (
        <Box
            display="flex"
            flexDirection="column"
            className={props.isMobile ? "mobile-top" : "desktop-top"}
        >
            <Box
                className={props.isMobile ? "mobile-box" : "desktop-box"}
                sx={{ paddingLeft: 3 }}
            >
                <h1>Walmart Pallet Labels</h1>

                <WalmartPalletLabelsForm
                    getBulkOrderInfo={getBulkOrderInfo}
                    isLoading={props.isLoading}
                    isMobile={props.isMobile}
                    toast={props.toast}
                />

                {orderInfo?.length > 0 ? (
                    <WalmartPalletLabelsTable
                        orders={orderInfo}
                        isMobile={props.isMobile}
                        isLoading={props.isLoading}
                        additionalPalletCounts={additionalPalletCounts}
                        setAdditionalPalletCounts={setAdditionalPalletCounts}
                        generatePalletLabels={generatePalletLabels}
                    />
                ) : null}

            </Box>
        </Box>
    );

}

export default WalmartPalletLabels;